const getDriveTypeDescription = (driveType, translate) => {
  switch (driveType.toUpperCase()) {
    case 'AWD':
      return translate('byo.drive.type.label.all.wheel.drive');
    case 'RWD':
      return translate('byo.drive.type.label.rear.wheel.drive');
    case '4WD':
      return translate('4WD.v3');
    case '2WD':
      return translate('2WD.v3');
    case 'FWD':
      return translate('byo.drive.type.label.front.wheel.drive');
    default:
      return '';
  }
};

export default getDriveTypeDescription;
